import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { LastLocationProvider } from "react-router-last-location";
import Header from "./layout/header";
import ls from "local-storage";
import Footer from "./layout/footer";
import Weeklyads from "./pages/weeklyads";
import Coupons from "./pages/coupons";
import Home from "./pages/home";
import Department from "./pages/department";
import Cart from "./pages/cart";
import Shop from "./pages/shop";
import Login from "./pages/login";
import Forgetpin from "./pages/forgetpin";
import Register from "./pages/register";
import Contact from "./pages/contact";
import Employment from "./pages/employment";
import Employment_HaysMarket from "./pages/employment-haysmarket";
import LinkCardRegistration from "./pages/linkcardregistration";
import Loyalty from "./pages/loyalty";
import Myaccount from "./pages/myaccount";
import Changepin from "./pages/changepin";
import Myrewards from "./pages/myrewards";
import Signup from "./pages/signup";
import Weeklyadsall from "./pages/weekly_adsall";
import WeeklyadsGallery from "./pages/weeklyads_gallery";
import Departmentall from "./pages/departmentall";
import ScrollToTop from "react-router-scroll-top";
import Catering from "./pages/catering";
import DownloadApp from "./pages/download_app";
import Page from "./pages/pages";
import CompanyPoliciesPage from "./pages/company_policies_page";
import CompanyPolicies from "./pages/company_policies";
import About from "./pages/about_page";
import About2 from "./pages/about_2";
import WebAccessibility from "./pages/company_policy_web_accessibility";
import Favicon from "react-favicon";
import * as CONFIG from "./pages/_config";
import axios from "axios";
// import ReactGA from 'react-ga';
import OrderOnline from "./pages/order_online";
import Pharmacy from "./pages/pharmacy";
import { useLocation } from "react-router";
import Seniorteals from "./pages/senior-tealsmarket";
import Employmentteals from "./pages/tealsemplyment";

import Floral from "./pages/eleden-department";

// import ReactPixel from 'react-facebook-pixel';
// import TagManager from 'react-gtm-module'
import Tutorial from "./pages/tutorial";
import Error from "./pages/error";
import DeleteAccount from "./pages/DeleteAccount";
import ProtectedRoute from "./ProtectedRoute";

if (
  CONFIG.DATA.ANALYTIC_FB_PIXEL_ID &&
  CONFIG.DATA.ANALYTIC_FB_PIXEL_ID !== "" &&
  CONFIG.DATA.ANALYTIC_FB_PIXEL_ID.length > 0
) {
  // console.log("React Facebook Pixel ", CONFIG.DATA.ANALYTIC_FB_PIXEL_ID);
  // Do something with the module.
  const advancedMatching = {}; // { em: 'some@email.com' }; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching
  const options = {
    autoConfig: true, // set pixel's autoConfig
    debug: false, // enable logs
  };
  // ReactPixel.init(CONFIG.DATA.ANALYTIC_FB_PIXEL_ID, advancedMatching, options);
}
// ReactPixel.pageView(); // For tracking page view
// ReactPixel.track(event, data); // For tracking default events, more info about events and data https://developers.facebook.com/docs/ads-for-websites/pixel-events/v2.9
// ReactPixel.trackSingle('PixelId', event, data); // For tracking default events, more info about events and data https://developers.facebook.com/docs/ads-for-websites/pixel-events/v2.9
// ReactPixel.trackCustom(event, data); // For tracking custom events
// ReactPixel.trackSingleCustom('PixelId', event, data); // For tracking custom events

if (
  CONFIG.DATA.ANALYTIC_GOOGLE_TAG_MANAGER_ID &&
  CONFIG.DATA.ANALYTIC_GOOGLE_TAG_MANAGER_ID !== "" &&
  CONFIG.DATA.ANALYTIC_GOOGLE_TAG_MANAGER_ID.length > 0
) {
  // console.log("Google Tag Manager", CONFIG.DATA.ANALYTIC_GOOGLE_TAG_MANAGER_ID);
  // const tagManagerArgs = {
  //     gtmId: CONFIG.DATA.ANALYTIC_GOOGLE_TAG_MANAGER_ID, //'GTM-KDN3WTL',
  //     dataLayerName: 'PageDataLayer'
  // }
  // TagManager.initialize(tagManagerArgs)
}

if (
  CONFIG.DATA.ANALYTIC_GOOGLE_SITE_ID &&
  CONFIG.DATA.ANALYTIC_GOOGLE_SITE_ID !== "" &&
  CONFIG.DATA.ANALYTIC_GOOGLE_SITE_ID.length > 0
) {
  // console.log("Google Analytics", CONFIG.DATA.ANALYTIC_GOOGLE_SITE_ID);
  // ReactGA.initialize(CONFIG.DATA.ANALYTIC_GOOGLE_SITE_ID);
  // ReactGA.pageview(window.location.pathname + window.location.search);
}

function RouterComponent() {
  let location = useLocation();

  useEffect(() => {
    // console.log(location.href);
    if (location && location.search === "?debug=1") {
      console.log(
        CONFIG.DATA.ANALYTIC_FB_PIXEL_ID,
        CONFIG.DATA.ANALYTIC_GOOGLE_TAG_MANAGER_ID,
        location
      );
    }

    // only log page view if its configured.
    if (
      CONFIG.DATA.ANALYTIC_FB_PIXEL_ID &&
      CONFIG.DATA.ANALYTIC_FB_PIXEL_ID !== "" &&
      CONFIG.DATA.ANALYTIC_FB_PIXEL_ID.length > 0
    ) {
      // ReactPixel.pageView();
    }
    //ga.send(['pageview', location.pathname])
    if (
      CONFIG.DATA.ANALYTIC_GOOGLE_TAG_MANAGER_ID &&
      CONFIG.DATA.ANALYTIC_GOOGLE_TAG_MANAGER_ID !== "" &&
      CONFIG.DATA.ANALYTIC_GOOGLE_TAG_MANAGER_ID.length > 0
    ) {
      const tagManagerArgs = {
        dataLayer: {
          userId: "web001",
          userProject: "website",
          page: location.pathname,
        },
        dataLayerName: "PageDataLayer",
      };

      // TagManager.dataLayer(tagManagerArgs)
    }
    if (
      CONFIG.DATA.ANALYTIC_GOOGLE_SITE_ID &&
      CONFIG.DATA.ANALYTIC_GOOGLE_SITE_ID !== "" &&
      CONFIG.DATA.ANALYTIC_GOOGLE_SITE_ID.length > 0
    ) {
      // ReactGA.pageview(window.location.pathname + window.location.search);
      // console.log(window.gtag);
      if (
        window.gtag &&
        typeof window.gtag !== "undefined" &&
        window.gtag !== null
      ) {
        // window.ga.send(['pageview', location.pathname])
        // window.gtag('pageview', 'sign_up')
      }
    }

    let currentHash = "";
    let currentPage = window.location.pathname.substring(1);
    // console.log(currentPage);
    if (currentPage == "" || currentPage == "/") {
      if (window.location.hash != "" && window.location.hash.length > 0) {
        currentHash = window.location.hash.substring(1);
        if (currentHash.indexOf("/") > 0) {
          currentPage = currentHash.substring(currentHash.lastIndexOf("/") + 1);
          // console.error(currentPage);
        }
      }
    }

    // to customize the css for each client, add client name in body as classname
    if (
      CONFIG.DATA.BACKEND_HOST != null &&
      CONFIG.DATA.BACKEND_HOST.length > 0
    ) {
      currentPage += " " + CONFIG.DATA.BACKEND_HOST;
    }

    if (currentPage != "" && currentPage != "/") {
      document.body.removeAttribute("class");
      // console.error(currentPage);
      currentPage = currentPage
        .replace("/", " ")
        .trim()
        .split(" ")
        .map(
          (className) => className && document.body.classList.add(className)
        );
    }
  }, [location]);

  return (
    <div>
      <Switch>
        <ProtectedRoute path="/change-pin" component={Changepin} />
        <ProtectedRoute path="/my-account" component={Myaccount} />
        <ProtectedRoute path="/my-rewards" component={Myrewards} />
        <ProtectedRoute path="/cart" component={Cart} />

        <Route
          exact
          path="/"
          component={CONFIG.DATA.ONLY_COUPONS ? Coupons : Home}
        />
        <Route path="/weekly-ads" exact component={Weeklyadsall} />
        <Route
          path="/weekly-ads-gallery/:id/:store"
          exact
          component={WeeklyadsGallery}
        />
        <Route path="/weekly-ads/:id/:store" component={Weeklyads} />
        <Route path="/coupons" exact component={Coupons} />
        <Route path="/coupons/:id" component={Coupons} />
        <Route path="/#/:name" component={Coupons} />
        <Route path={["/department", "/department/"]} exact component={Departmentall} />
        <Route path="/department/:id" component={Department} />
        <Route path="/tealsemp" component={Employmentteals} />

        {/* // This was added for Testing before building AOG
            <Route path="/shop" component={Shop} /> 
            */}
        <Route path="/login" component={Login} />
        <Route path="/forget-pin" component={Forgetpin} />
        <Route path="/simple-register" component={Register} />
        <Route path="/contact" component={Contact} />
        <Route
          path="/employment"
          component={
            CONFIG.DATA.ALLOW_EMPLOYMENT_SCREEN
              ? CONFIG.DATA.BACKEND_HOST == "haysmarket"
                ? Employment_HaysMarket
                : Employment
              : Home
          }
        />

        <Route
          path="/link-card-registration"
          component={LinkCardRegistration}
        />
        <Route path="/loyalty" component={Loyalty} />

        <Route path="/register" component={Signup} />
        <Route path="/catering" component={Catering} />
        <Route path="/download-our-app" component={DownloadApp} />
        <Route path="/page/:page" component={Page} />
        <Route path="/company-policies" exact component={CompanyPoliciesPage} />
        <Route
          path="/how-to-delete-your-account"
          exact
          component={DeleteAccount}
        />
        <Route
          path="/company-policies/web-accessibility"
          exact
          component={WebAccessibility}
        />
        <Route path="/company-policies/:page" component={CompanyPolicies} />
        <Route
          path="/about"
          exact
          component={CONFIG.DATA.THEME !== 2 ? About : About2}
        />
        <Route
          path="/about/:page"
          component={CONFIG.DATA.THEME !== 2 ? About : About2}
        />
        <Route
          path="/order-online"
          component={
            CONFIG.DATA.BACKEND_HOST == "twojsthriftway" ? OrderOnline : Home
          }
        />
        <Route
          path="/pharmacy"
          component={CONFIG.DATA.BACKEND_HOST == "pruetts" ? Pharmacy : Home}
        />

        <Route
          path="/tutorial"
          exact
          component={
            CONFIG.DATA.HAS_SHOP_TUTORIAL_PAGE == true ? Tutorial : Home
          }
        />
        <Route
          path="/tutorial/:image"
          exact
          component={
            CONFIG.DATA.HAS_SHOP_TUTORIAL_PAGE == true ? Tutorial : Home
          }
        />
        <Route
          path="/seniorteals"
          component={
            CONFIG.DATA.BACKEND_HOST == "tealsmarket" ? Seniorteals : Home
          }
        />
        <Route path="/departments/floral" component={Floral} />
        <Route path="/error" component={Error} />

        <Route path="*" component={CONFIG.DATA.ONLY_COUPONS ? Coupons : Home} />
      </Switch>
    </div>
  );
}

function Main() {
  const [Data, setData] = useState();
  const [configData, setConfigData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  function initializeReactGA() {
    // ReactGA.initialize('UA-89453068-4');
    // ReactGA.pageview(window.location.pathname + window.location.search);
  }

  async function fetch() {
    const form = new FormData();
    setIsLoading(true);
    // form.append('apiurl', `https://whitesfoodliner.com/assets/json/whites.json`);
    form.append("method", "GET");
    const apiurl =
      "https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/clientinfo?FileName=rbgfoods";
    const config = {
      method: "GET",
      url: apiurl,
      data: form,
    };
    try {
      const response = await axios(config);
      setData(response.data);
      CONFIG.DATA = response.data;
      setIsLoading(false);
    } catch (error) {
      setIsError(true);
    }
  }

  useEffect(() => {
    // fetch();
  }, []);

  return (
    <React.Fragment>
      {isError && <div>Something went wrong ...</div>}

      {isLoading ? (
        <div>Loading ...</div>
      ) : (
        <React.Fragment>
          <Favicon url={CONFIG.DATA.LOGO_FAVICON} />
          <Router basename={CONFIG.DATA.BASEPATH}>
            <LastLocationProvider>
              <ScrollToTop>
                <Header />
                <RouterComponent />
                <Footer />
              </ScrollToTop>
            </LastLocationProvider>
          </Router>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}
export default Main;
